import { useContext } from "react";
import Globalview from "../../components/Globalview";
import Loader from "../../components/Loader";
import RowIncidents from "./RowIncidents";
import { Incidentscolumns } from "../../components/headerContent";
import IncidentsActiveFilter from "./IncidentsActiveFilter";
import Table from "../../components/Table";
import { AuthContext } from "../../context/AuthContext";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import NumberCard from "../../components/Card/NumberCard";
import { useTranslation } from "react-i18next";

export default function TableIncidents({
  incidents,
  handleDisplayAllTickets,
  incidentsFilteredByGraph,
  isChartClicked,
}) {

  // Import context
  const { apiUrl, user } = useContext(AuthContext);
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  // Handle activation of incidents
  const [selectedIncidents, setSelectedIncidents] = useState([]);
  const [isActive, setIsActive] = useState(null);
  const [isCheckBox, setIsCheckBox] = useState(false);
  const [incidentsFilteredByActive, setIncidentsFilteredByActive] = useState(
    []
  );
  const [resetValue, setResetValue] = useState(false);

  const filterIncidentsByIsActive = () => {
    let newIncidentsArray;
    newIncidentsArray = !isChartClicked
      ? incidents.data.filter((incident) => {
        return incident.is_active === isActive;
      })
      : incidentsFilteredByGraph.filter((incident) => {
        return incident.is_active === isActive;
      });

    setIncidentsFilteredByActive(newIncidentsArray);
  };

  useEffect(() => {
    !incidents.isLoading && filterIncidentsByIsActive();
  }, [isActive, incidents.data, incidentsFilteredByGraph]);

  // Display incidents by status
  const [incidentsByStatus, setIncidentsByStatus] = useState([]);
  const [valueType, setValueType] = useState("all");
  const activeCounts = {
    "Non résolu": 0,
    Résolu: 0,
  };

  const incidentsFilterByStatus = () => {
    const filterByStatus = incidents.data.filter((item) => {
      switch (true) {
        case valueType === "Résolu":
          return item.statuscode === "5";
          break;
        case valueType === "Non résolu":
          return item.statuscode !== "5";
          break;
      }
    });
    setIncidentsByStatus(filterByStatus);
  };


  useEffect(() => {
    !incidents.isFetching && incidentsFilterByStatus();
  }, [valueType]);

  // function to update active request
  const updateActiveRequest = async () => {
    if (selectedIncidents.length > 0) {
      const promises = selectedIncidents.map((item) => {
        const { date_last_exec, sla, entreprise_id, ...updatedItem } = item;
        const updatedData = {
          ...updatedItem,
          is_active: isActive === "1" ? 0 : 1,
          entreprise: user.entrepriseId,
        };

        return axios(`${apiUrl}incident/${item.ticketnumber}/edit`, {
          method: "put",
          withCredentials: true,
          data: updatedData,
        });
      });

      const responses = await Promise.all(promises);
      return responses;
    }
  };

  const updateActiveIncidents = useMutation({
    mutationFn: updateActiveRequest,
    onSuccess: () => {
      queryClient.invalidateQueries(["incidents"]);
      setIsActive(null);
      setSelectedIncidents([]);
    },
  });

  useEffect(() => {
    isActive !== null && setIsCheckBox(true);
  }, [isActive]);

  return (
    <>
      <section className="page-section">
        <NumberCard
          title="Tickets"
          number={
            isActive !== null ? incidentsFilteredByActive.length : isChartClicked
              ? incidentsFilteredByGraph.length : incidentsByStatus.length > 0
                ? incidentsByStatus.length : incidents.data.length
          }
          logo={faCircleCheck}
          color={"#AEC353"}
          stylesIcons={"logo-certificats"}
        />
      </section>
      <section className="page-section">
        {!isChartClicked && (
          <Globalview
            data={incidents.data}
            objectKey="statuscode"
            countObject={activeCounts}
            setValueType={setValueType}
            click
            resetValue={resetValue}
            setResetValue={setResetValue}
          />
        )}
        {!isChartClicked && user.roles.includes("ROLE_SUPERADMIN") && (
          <IncidentsActiveFilter
            setIsActive={setIsActive}
            updateActiveIncidents={updateActiveIncidents}
            isActive={isActive}
            selectedIncidents={selectedIncidents}
          />
        )}
        {valueType !== "all" && (
          <button
            className="buttons-ecp ml-1"
            onClick={() => {
              setValueType("all"),
                setResetValue(true);
            }}
          >
            {" "}
            {t('Réinitialiser')}
          </button>
        )}
      </section >
      {!updateActiveIncidents.isPending ? (
        <div className='cato-content-table mt-1'>
          <Table
            tableData={
              isActive !== null
                ? incidentsFilteredByActive
                : isChartClicked
                  ? incidentsFilteredByGraph
                  : incidentsByStatus.length > 0
                    ? incidentsByStatus
                    : incidents.data
            }
            tableColumns={Incidentscolumns}
            rowComponent={RowIncidents}
            checkbox={isCheckBox}
            selectedIncidents={selectedIncidents}
            setSelectedIncidents={setSelectedIncidents}
          />
        </div>
      ) : (
        <Loader />
      )
      } {" "}
    </>
  );
}
